@if (visible) {
  <div class="modal_customer"
    >
    @if (cbmData != null) {
      <div class="modal_customer_body">
        <div class="_container">
          <div class="cbm-details">
            <div class="details-container">
              <div class="cbm-name">{{ cbmData['contractor']['cbmName'] }} </div>
              <!-- <div class="cbm-rating">
              <img    class="star"
                *ngFor=" let x of [].constructor(getRating())"
                src="assets/img/icons/new_icons/cb_star_active.svg" alt="">
                <img    class="star"
                  *ngFor=" let x of [].constructor(5-getRating())"
                  src="assets/img/icons/new_icons/cb_star_inactive.svg" alt="">
                </div> -->
                <app-starratemodal [rating]="getRatingValue(getRating())" [reviews]="cbmData['feedback'].length" [starOnly]="false"></app-starratemodal>
                <br>
                  <div class="data-label">PCAB License Number</div>
                  <div class="data-item">{{ cbmData['contractor']['pcabNo'] }}</div>
                  <br>
                    <div class="data-label">Residential/ Non-residential/ Mixed Tag</div>
                    <div class="data-item">{{ cbmData['contractor']['class'] | titlecase }}</div>
                    <br>
                      <div class="data-label">Other Services Offered</div>
                      <div class="data-item services" style="width: 460px;">
                        {{ cbmData['servicetype']['name'] || '---' }}
                      </div>
                      <br>
                        <div class="data-label">Areas Served</div>
                        <div class="data-item cities"
                          style="width: 460px;"
                          [ngClass]="{ 'expand-cities' : expandCities }">
                          @for (item of cbmData['city']; track item; let index = $index) {
                            {{ item['value'] | titlecase }}{{ index+1 < cbmData['city'].length ? ",":"" }}
                          }
                        </div>
                        @if (cbmData['city'].length > 0) {
                          <div class="view-all"
                            (click)="expandCities = !expandCities">
                            {{ expandCities ? 'Hide Cities':'View all Cities' }}
                          </div>
                        }
                        <br>
                          <button class="button button-active" style="width: 290px" (click)="select()">Select this CBM</button>
                        </div>
                      </div>
                      <div class="cbm-reviews">
                        <div class="modal_customer_close" (click)="dismiss()">
                          <img src="assets/img/icons/new_icons/modal_close.svg"/>
                        </div>
                        <div class="review-header">Customer Reviews</div>
                        <br>
                          <div class="review-container">
                            <div class="d-flex flex-row align-items-center">
                              Sort By
                              <div style="width: 10px;"></div>
                              <select-cst [width]="'280px'"
                                [items]="['Rating','Most Recent']"
                                [selectedItem]="sortType"
                                [placeholder]="'Select Option'"
                                (itemSelected)="sortType = $event">
                              </select-cst>
                            </div>
                            <div class="review-list">
                              @if (cbmData['feedback'].length>0) {
                                @for (item of getReviews(sortType); track item; let index = $index) {
                                  <div class="review-item">
                                    <!-- <div class="review-item-stars">
                                    <img    class="star"
                                      *ngFor=" let x of [].constructor(computeRating(item))"
                                      src="assets/img/icons/new_icons/cb_star_active.svg" alt="">
                                      <img    class="star"
                                        *ngFor=" let x of [].constructor(5-computeRating(item))"
                                        src="assets/img/icons/new_icons/cb_star_inactive.svg" alt="">
                                      </div> -->
                                      <app-starratemodal [rating]="computeRating(item)" [reviews]="cbmData['feedback'].length" [starOnly]="true"></app-starratemodal>
                                      <div class="review-item-message">
                                        {{ item['comment'] }}
                                      </div>
                                      <div class="review-item-tags">
                                      </div>
                                      <div class="review-item-user">
                                        <div>{{ item['user'] }}</div>
                                        <div>{{ item['date_created'] }}</div>
                                      </div>
                                    </div>
                                  }
                                }
                                @if (cbmData['feedback'].length == 0) {
                                  <div class="no-review">
                                    This CBM has no reviews yet
                                  </div>
                                }
                                @if (cbmData['feedback'].length>0) {
                                  <button class="button button-default text-center"
                                    (click)="viewAll()"
                                    style="width: 290px;">
                                    View All Reviews
                                  </button>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
